import { render, staticRenderFns } from "./wx-user-tags-manager.vue?vue&type=template&id=3be10b1c&scoped=true"
import script from "./wx-user-tags-manager.vue?vue&type=script&lang=js"
export * from "./wx-user-tags-manager.vue?vue&type=script&lang=js"
import style0 from "./wx-user-tags-manager.vue?vue&type=style&index=0&id=3be10b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be10b1c",
  null
  
)

export default component.exports